import { BehaviorSubject, Observable } from 'rxjs';

export interface IVisibleStateProvider {
  get visible(): Observable<boolean>;
}

export interface IValidStateChangeProvider {
  validStateChange$: Observable<boolean>;
}

export class ValidStateProvider implements IValidStateChangeProvider {
  private valid: boolean | undefined = undefined;
  private validSubject = new BehaviorSubject<boolean>(false);
  validStateChange$ = this.validSubject.asObservable();

  constructor(initialState?: boolean) {
    this.valid = initialState;
  }

  public getValid(): boolean | undefined {
    return this.valid;
  }

  public setValid(valid: boolean) {
    if (this.valid !== valid) {
      this.valid = valid;
      this.validSubject.next(valid);
    }
  }
}
